import { Button, Divider } from "@shopify/polaris";
import styles from "./Placeholder.module.css";
import { useContext } from "react";

import { TargetingForm } from "../TargetingForm";
import { PlaceholderContext } from "./Placeholder";
import { BundleTypes } from "../constants";
import PlaceholderAdvanced from "./PlaceholderAdvanced";

const PlaceholderTargetForm = () => {
    const context = useContext(PlaceholderContext);
    const { fields, handleNext, dispatchBundleConfig, submit, bundleConfig } = context;

    const { value: targeting, onChange } = fields.targeting;

    const dispatchBundleTargeting = (obj: object) => {
        dispatchBundleConfig({
            key: "targeting",
            payload: { ...targeting, ...obj },
        });
        onChange({ ...targeting, ...obj });
    };

    return (
        <div className={styles.formWrapper}>
            <div style={{ marginBottom: 10 }}>
                <Divider borderColor="border" />
            </div>
            <div className={styles.collapsibleFormBox} style={{ marginBottom: "-12px" }}>
                <PlaceholderAdvanced bundleType={BundleTypes.BB_PLACEHOLDER} submit={submit} context={context} />
            </div>
            <TargetingForm
                targeting={targeting}
                dispatchBundleTargeting={dispatchBundleTargeting}
                bundleType={BundleTypes.BB_PLACEHOLDER}
                dispatchBundleConfig={dispatchBundleConfig}
                submit={submit}
                additional={fields}
                bundleConfig={bundleConfig}
            />
            <div className={styles.dividerStyle}>
                <Divider borderColor="border" />
            </div>

            <div className={styles.bottomRowCta}>
                <Button onClick={() => handleNext(1, "Design")}>Back</Button>

                {/* <Button onClick={() => handleNext(3, "Setting")}>Next</Button> */}
            </div>
        </div>
    );
};

export default PlaceholderTargetForm;
